import { render } from "./DeliveryNotes.vue?vue&type=template&id=25e42976&scoped=true"
import script from "./DeliveryNotes.vue?vue&type=script&lang=js"
export * from "./DeliveryNotes.vue?vue&type=script&lang=js"

import "./DeliveryNotes.vue?vue&type=style&index=0&id=25e42976&lang=css"
import "./DeliveryNotes.vue?vue&type=style&index=1&id=25e42976&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/FLOCKR/FLOCKER-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25e42976"]])

export default __exports__